import React from 'react';
import { Box, Typography, Chip, useTheme } from '@mui/material';
import { 
  Clock, 
  AlertTriangle, 
  CheckCircle, 
  Gavel,
  Users,
  CalendarClock,
  Video,
  Bell,
  Calendar
} from 'lucide-react';

interface CalendarLegendProps {
  isMobile?: boolean;
}

export const CalendarLegend: React.FC<CalendarLegendProps> = ({ isMobile }) => {
  const theme = useTheme();

  const legendItems = [
    // Event Types
    {
      label: 'Court Date',
      icon: <Gavel size={14} />,
      color: 'error',
      variant: 'filled',
    },
    {
      label: 'Meeting',
      icon: <Users size={14} />,
      color: 'info',
      variant: 'outlined',
    },
    {
      label: 'Deadline',
      icon: <CalendarClock size={14} />,
      color: 'warning',
      variant: 'outlined',
    },
    {
      label: 'Hearing',
      icon: <Gavel size={14} />,
      color: 'error',
      variant: 'outlined',
    },
    {
      label: 'Deposition',
      icon: <Video size={14} />,
      color: 'secondary',
      variant: 'outlined',
    },
    {
      label: 'Reminder',
      icon: <Bell size={14} />,
      color: 'info',
      variant: 'outlined',
    },
    {
      label: 'Other',
      icon: <Calendar size={14} />,
      color: 'default',
      variant: 'outlined',
    },
  ];

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        Legend
      </Typography>
      <Box sx={{ 
        display: 'flex', 
        gap: 1, 
        flexWrap: 'wrap',
        '& .MuiChip-root': {
          height: isMobile ? 24 : 28,
          '& .MuiChip-label': {
            fontSize: isMobile ? '0.75rem' : '0.875rem',
          },
        },
      }}>
        {legendItems.map((item) => (
          <Chip
            key={item.label}
            icon={item.icon}
            label={item.label}
            size="small"
            color={item.color as any}
            variant={item.variant as any}
          />
        ))}
      </Box>
    </Box>
  );
};